import { render, staticRenderFns } from "./GraphScore.vue?vue&type=template&id=71ced664&scoped=true&"
import script from "./GraphScore.vue?vue&type=script&lang=ts&"
export * from "./GraphScore.vue?vue&type=script&lang=ts&"
import style0 from "./GraphScore.vue?vue&type=style&index=0&id=71ced664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ced664",
  null
  
)

export default component.exports